import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./landing/landing.routes').then((m) => m.LANDING_ROUTES_CONFIG),
  },
  {
    path: 'app',
    loadChildren: () => import('./app/app.routes').then((m) => m.APP_ROUTES),
  },
  { path: '**', redirectTo: '' },
];
